import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StyleService } from '../../services';
import { BreakOfferConfig, BreakItem } from '../../../../../builder-app/src/app/feature/cms-offers/components/models/cms-offer-detail';

@Component({
  selector: 'app-breakvalue',
  templateUrl: './breakvalue.component.html',
  styleUrls: ['./breakvalue.component.scss']
})
export class BreakvalueComponent implements OnInit {
  @Input() data: BreakOfferConfig = {};

  @Input() tab!: any;

  @Output()
  public exitSection = new EventEmitter();

  @Output()
  public select = new EventEmitter();

  public couponCost: number = 0;

  public optionSelected: boolean = false;

  constructor(
    public readonly styleService: StyleService
  ) { }

  public get getBreakdownTitle() {
    return this.tab.configurations?.breakdown?.buttonBreakValueTitle ?? 'How would you like your offer broken down?';
  }

  public get getBackButtonStyle() {
    return this.tab.configurations?.breakdown?.goBackButton;
  }

  public get getSelectButtonStyle() {
    return this.tab.configurations?.breakdown?.selectButton;
  }

  public get getOutlineStyle() {
    return this.tab.configurations?.breakdown?.outlineColour;
  }

  // to preserve keyvalue pipe original order
  valueOrder = (a: any, b: any): number => {
    return 0;
  };

  ngOnInit() {
    this.optionSelected = false;
  }

  numGroups(group: any) {
    return Object.keys(group).length - 1;
  }

  calculateCost(value: any) {
    let total = 0;

    Object.keys(value).forEach((key) => {
      total += value[key].qty * value[key].amt;
    });

    return total;
  }

  selectItem(item: BreakItem[]) {
    this.optionSelected = true;
    console.log("Option selected: ", item);
    this.select.emit(item);
  }

  exitBreakValue(): void {
    this.exitSection.emit();
  }
}
